export class LoginResponse {
    ErrorMessage: string = "";
    IsError: boolean = false;
    ErrorCode: string = "";
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}